import React, { useState, useEffect } from 'react';
import IconCheckbox from '../../../../../components/icon-checkbox';
import { TimerIcon } from '../../../../../resource/icons';
import { useSearchParams } from '../../../shared/lib/searchParams';
import { shutdownFiltersData } from '../../../shared/constants';
import { debounce } from '../../../../../helpers/debounce';

const {
  filters: { onlyActive, search },
  changeFilterDelay: delay,
} = shutdownFiltersData;

const toBool = (value) => JSON.parse(value);

const ToggleOnlyActive = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const onlyActiveParam = searchParams.get(onlyActive.name);

  const [value, setValue] = useState(toBool(onlyActiveParam));

  const handleChange = (value) => {
    setValue(value);

    debounce(() => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(onlyActive.name, value);
      newParams.delete(search.name);
      setSearchParams(newParams);
    }, delay)();
  };

  useEffect(() => {
    if (onlyActiveParam && onlyActiveParam !== `${value}`) {
      setValue(toBool(onlyActiveParam));
    }
  }, [onlyActiveParam]);

  return (
    <IconCheckbox
      icon={<TimerIcon />}
      value={value}
      onChange={handleChange}
    >
      Только активные
    </IconCheckbox>
  );
};

export default ToggleOnlyActive;
